<script>
import { required } from "vuelidate/lib/validators";
import { equalTo } from "../../../helpers/validators_files";

export default {
  components: {},
  props: {},
  data() {
    return {
      invalidCheck: "",
    };
  },
  validations: {
    invalidCheck: { required, equalTo: equalTo(true) },

    form: ["invalidCheck"],
  },
  methods: {
    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div>
    <div class="row">
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">تعليمات وشروط التقديم</h5></div>

      <div class="col-md-12">
        <ol>
          <!-- <li>
            <p>استلام وحدة سكنية واحدة فقط لنفس عائلة الشهيد .</p>
          </li> -->
          <li>
            <p>
              يحق للمستفيدين من الدرجة الاولى فقط الاستفادة من القرض بالنسبة لعائلة الشهيد
              .
            </p>
          </li>
          <li>
            <p>
              في حال كان الشهيد لا يملك اي صلة قرابة من الدرجة الاولى فعلى المستفيد من
              الدرجة الثانية الحضور الى مقر المديرية للتقديم على الاستمارة .
            </p>
          </li>
          <li>
            <p>
              يجب ان يكون عمر مقدم الطلب من 18 سنة الى 62 سنة للتقديم على الاستمارة حسب
              شروط المصرف العقاري .
            </p>
          </li>
          <li>
            <p>
              يجب ان يكون المستفيد من سكنة محافظة بغداد ويتم اثبات ذلك عن طريق بطاقة السكن
              او تأييد السكن .
            </p>
          </li>
          <li>
            <p>
              اختيار مساحة الوحدة السكنية هو غير نهائي حيث تسلم الوحدة السكنية حسب اسبقية
              التقديم وبناء على التخصيص من قبل هيئة الاستثمار .
            </p>
          </li>
          <li>
            <p>يجب التعهد باحضار كفيل بعد التسجيل على الاستمارة لغرض اكمال الاجراءات .</p>
          </li>
          <li>
            <p>تحجب الاستمارة في حال كان هناك اي معلومات غير صحيحة عند التسجيل .</p>
          </li>
        </ol>

        <div class="form-check check-promise mb-3">
          <label class="form-check-label" for="invalidCheck">
            اتعهد بصحة كافة البيانات التي سيتم ادخالها وبخلافه اتحمل كافة التبعات
            القانونية .
          </label>
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="invalidCheck"
            required=""
            v-model="invalidCheck"
            :class="{ 'is-invalid': $v.invalidCheck.$error }"
          />
          <div v-if="$v.invalidCheck.$error" class="invalid-feedback">
            <span v-if="!$v.invalidCheck.required || !$v.invalidCheck.equalTo"
              >للتقديم على الاستمارة يجب الموافقة على التعهد</span
            >
          </div>
        </div>
      </div>
      <!-- <div class="col-md-3">
        <b-button class="play-btn" v-b-modal.modal-center></b-button>
        <p class="text-center mt-3">مشاهدة الفيديو التوضيحي</p>
      </div>

      <b-modal
        id="modal-center"
        centered
        size="xl"
        title="استمارة الوحدات السكنية"
        title-class="font-18"
        hide-footer
      >
        <div class="ratio ratio-16x9">
          <video src="@/assets/video/info.mp4" controls autoplay></video>
        </div>
      </b-modal> -->
    </div>
  </div>
  <!-- end page title -->
</template>
